import React from "react";
import Button from "../../../Reusable/Button";
import Modal from "../../../Reusable/Modal";
// @ts-ignore
import { tw } from "@careinfo/tailwind";
import APIS from "../../../../constant/Endpoint";
import useDeleteHook from "../../../../customHooks/useDeleteHook";
import { toast } from "react-toastify";
import { navigateToUrl } from "single-spa";
import { classNames } from "../../../Reusable/DatePicker/helpers";
import Spinner from "../../../Reusable/Spinner";

interface Props {
  isOpen: boolean;
  setIsOpen: (val: boolean) => void;
  onConfirm?: () => void;
  groupId: string;
}

const DeleteContact: React.FC<Props> = ({
  isOpen,
  setIsOpen,
  groupId,
  onConfirm,
}) => {
  const { mutateAsync, isLoading } = useDeleteHook({
    queryKey: ["contacts"],
  });

  const handleDelete = async () => {
    const url = `${APIS.CONTACT}${groupId}/`;

    try {
      const res = await mutateAsync({ url });
      if (res?.status === 204 || res?.status === 200) {
        setIsOpen(false);
        if (onConfirm) onConfirm();
      }
    } catch (err) {
      console.error("Error deleting group:", err);
    }
  };

  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen} title="Delete Contact">
      <div
        className={tw`flex flex-col items-center justify-center w-full max-w-md px-4 py-6`}
      >
        <p className={tw`text-center text-gray-700 text-base mb-6`}>
          Are you sure you want to remove this contact? This action cannot be
          undone.
        </p>
        <div className={tw`flex w-full justify-center gap-4`}>
          <div className={tw`w-32`}>
            <button
              type={"button"}
              onClick={() => setIsOpen(false)}
              className={classNames(
                tw`bg-gray-500 w-full text-white py-2 rounded my-2 focus:outline-none focus-visible:ring-2 ring-offset-1`
              )}
            >
              Cancel
            </button>
          </div>
          <div className={tw`w-32`}>
            <button
              type={"button"}
              disabled={isLoading}
              onClick={handleDelete}
              className={classNames(
                isLoading ? tw`bg-gray-500` : tw`bg-red-500`,
                tw`w-full text-white py-2 rounded my-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-red-500 ring-offset-1`
              )}
            >
              {isLoading ? <Spinner /> : "Delete"}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteContact;
